import React, { useState, useEffect } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  DateInput,
  Labeled,
  ReferenceInput,
  ReferenceField,
  FunctionField
} from "react-admin";
import axios from "axios";
import { hostname } from "../../providers/api";
import { useTokenOps } from "../../components/TokenContext";
import { REFERENCE_TYPES, PROJECT_FUNCTIONAL_UNITS, _STATUS, NAMES } from "../../consts";
import { formatBcomeVersionLabel } from "../../components/DbVersion";

const EditProjects = (props) => {
  const tokenOps = useTokenOps();
  const [packagingIdFilter, setPackagingIdFilter] = useState("");
  const [visibilityPrimary, setVisibilityPrimary] = useState({ 0: false, 1: false, 2: false })
  const [visibilitySecondary, setVisibilitySecondary] = useState({ 0: false, 1: false, 2: false })
  const [visibilityTertiary, setVisibilityTertiary] = useState({ 0: false, 1: false, 2: false })

  const handleFocus = (type, index) => {
    switch (type) {
      case "primaryPackaging":
        setVisibilityPrimary({ ...visibilityPrimary, [index]: true })
        break
      case "secondaryPackaging":
        setVisibilitySecondary({ ...visibilitySecondary, [index]: true })
        break
      case "tertiaryPackaging":
        setVisibilityTertiary({ ...visibilityTertiary, [index]: true })
        break
      default:
        break
    }
  }

  const getPackagingId = () => {
    axios.get(hostname + "/lcaCategory", {
      headers: {
        "Content-type": "application/json",
        authorization: "Bearer " + tokenOps.account?.accessToken,
      },
    })
      .then(({ data }) => {
        let valueIdPackaging = data.find(d => d.name === "Packaging");
        if (valueIdPackaging) setPackagingIdFilter(valueIdPackaging.id);
      })
      .catch(error => console.log(error))
  }

  useEffect(() => {
    getPackagingId();
  }, [])

  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="name" />
        <Labeled label="Data collection"></Labeled>
        <TextInput source="dataCollectionURL" label="Data collection url" required={false} />
        <TextInput source="folderURL" label="Folder url" required={false} />
        <SelectInput source="status" choices={_STATUS} label="Status" />
        <DateInput source="closingDate" required={false} />

        <Labeled label="Type of packaging">
          <div style={{ width: "max-content", display: "flex", flexDirection: "row", gap: 10 }}>
            {
              NAMES.map((item, index) => {
                const validator = item.key === 1 ? visibilityPrimary : item.key === 2 ? visibilitySecondary : visibilityTertiary;

                return (
                  <div key={item.key}>
                    <span className={props.view} style={{ minWidth: 160 }}>{(item.name)}</span>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                      {
                        validator[0]
                          ? <ReferenceInput
                            label={`1r packaging`}
                            source={`${item.source}[0].id`}
                            reference="process"
                            key={index}
                            filter={{ categoryId: packagingIdFilter }}
                          >
                            <SelectInput source="name" />
                          </ReferenceInput>
                          : <TextInput label="1r packaging" source={`${item.source}[0].name`} onFocus={() => handleFocus(item.source, 0)} />
                      } {
                        validator[1]
                          ? <ReferenceInput
                            label={`2nd packaging`}
                            source={`${item.source}[1].id`}
                            reference="process"
                            key={index + 1}
                            filter={{ categoryId: packagingIdFilter }}
                          >
                            <SelectInput source="name" />
                          </ReferenceInput>
                          : <TextInput label="2nd packaging" source={`${item.source}[1].name`} onFocus={() => handleFocus(item.source, 1)} />
                      } {
                        validator[2]
                          ? <ReferenceInput
                            label={`3th packaging`}
                            source={`${item.source}[2].id`}
                            reference="process"
                            key={index + 2}
                            filter={{ categoryId: packagingIdFilter }}
                          >
                            <SelectInput source="name" />
                          </ReferenceInput>
                          : <TextInput label="3th packaging" source={`${item.source}[2].name`} onFocus={() => handleFocus(item.source, 2)} />
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
        </Labeled>
        <SelectInput source="referenceType" choices={REFERENCE_TYPES} label="References type" />
        <SelectInput source="functionalUnit" choices={PROJECT_FUNCTIONAL_UNITS} label="Functional unit" />
        {/* Version is read-only here: it can only be changed via the version
            selector in the project upload flow (see ProjectShow Calculation tab). */}
        <Labeled label="Version">
          <ReferenceField
            source="bcomeVersionId"
            reference="bcomeVersion"
            link={false}
          >
            <FunctionField render={formatBcomeVersionLabel} />
          </ReferenceField>
        </Labeled>
        <BooleanInput source="supplyMapDigitalization" />

        <BooleanInput label="Km from origin to warehouse" source="originWarehouseKm" />
      </SimpleForm>
    </Edit>
  );
};

export default EditProjects;
